<template>
    <div class="save-search-form">
        <p>
            {{ lang.sentence }}
        </p>

        <tecno-map
            ref="map"
            :options="options"
            :section="section"
            class="tecnomap-container">
        </tecno-map>

        <div class="search-title">
            {{ title }}
        </div>

        <div class="badges">
            <span
                v-for="(param, key) in filters"
                :key="key"
                :class="'badge badge-' + $root.network + '-' + (key.substring(0, key.indexOf('|')) ? key.substring(0, key.indexOf('|')) : key)"
            >
                {{ param.title | capitalize }}
            </span>
        </div>


        <form @submit.prevent="saveSearch" @keydown="form.errors.clear($event.target.name)">
            <my-input
                v-if="is_guest()"
                v-model="form.email"
                name="email"
                type="email"
                :label="lang.labels.email"
            />

            <input v-else type="hidden" v-model="form.email">

            <error-span :error="form.errors.get('email')"></error-span>

            <div class="privacy-policy" v-html="lang.privacy_policy"></div>

            <marketing-checkbox v-model="form.marketing" :lang="lang" />

            <error-span :error="form.errors.get('marketing')"></error-span>

            <button class="btn btn-network">
                {{ lang.labels.save }}
            </button>
        </form>
    </div>
</template>

<script>
import TecnoMap from './maps/Map'
import MarketingCheckbox from './form/MarketingCheckbox'

import { Form } from '../classes/Form'

export default {
    components: {
        'marketing-checkbox': MarketingCheckbox,
        'tecno-map': TecnoMap,
    },

    props: {
        search: {
            type: Object,
            required: false,
        },

        section: {
            type: String,
            required: false,
        },

        title: {
            type: String,
            required: true,
        },

        map_center: {
            default: false
        },

        map_polygons: {
            default: false
        }
    },

    data() {
        return {
            filters : null,

            form: new Form({
                email: this.$root.user_email,
                params: this.search,
                marketing: false,
                title: this.title,
            }),

            options: {
                currentZoom: 9,
                style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                mapCenter: {
                    // coords: [lon, lat],
                    // marker: true
                },

                features: {
                    uriCoords: false,
                    scrollZoom: false,
                    dragRotate: false,
                    touchZoomRotate: false,
                    interactive: false
                },

                modules: {
                    drawer: {
                        modes: [],
                        insideColor: '#078c33',
                        outsideColor: '#00d054',
                        fillColor: '#089642',
                        textColor: '#fff'
                    }
                }
            },

            rules: {
                email: ['required'],
                marketing: ['required'],
                'params.polygon': ['required_without_all:params.cardinal,params.district,params.city,params.province,params.region'],
                'params.cardinal': ['required_without_all:params.polygon,params.district,params.city,params.province,params.region'],
                'params.district': ['required_without_all:params.polygon,params.cardinal,params.city,params.province,params.region'],
                'params.city': ['required_without_all:params.polygon,params.cardinal,params.district,params.province,params.region'],
                'params.province': ['required_without_all:params.polygon,params.cardinal,params.district,params.city,params.region'],
                'params.region': ['required_without_all:params.polygon,params.cardinal,params.district,params.city,params.province'],
            },
        }
    },

    computed: {
        lang() {
            return this.$root.lang.save_search_form
        },

        paramsError() {
            let paramsError = Object.keys(this.form.errors.errors)
                .reduce(
                    (acc, key) => acc || key.includes('params'),
                    false
            )
            return paramsError && this.lang && this.lang.errors
                ? this.lang.errors.params
                : false
        }
    },

    methods: {
        saveSearch() {
            if (!this.form.validate(this.rules)) {
                if (this.paramsError) {
                    if (typeof Sentry !== 'undefined') {
                        Sentry.captureException(new Error('SaveSearchForm Error'), scope => {
                            scope.setExtra('params', JSON.stringify(this.form));
                            scope.setTag('query', window.location.pathname);
                            return scope;
                        });
                    }

                    flash(this.lang.errors.params, 'warning')
                    this.$parent.close()
                    return
                }
                return false
            }

            this.form.post('/api/saved-searches')
                .then((data) => {
                    if (data.response.status_code === 409) {
                        flash(this.lang.errors.already_saved, 'warning')
                        this.$parent.close()
                        return
                    }

                    if (data.response.errore && data.response.errore == 'devi-registrarti') {
                        flash(this.lang.errors.must_register, 'warning')
                        this.$parent.close()
                        return
                    }

                    flash(this.lang.flash.success)

                    this.$parent.close()

                    if (typeof ga != 'undefined') {
                        ga('send', 'pageview', '/obiettivi/form/alertemail/compilato/');
                    }
                })
                .catch(error => {
                    // console.log(error)
                })
        }
    },

    created() {
        if (this.$root.network == 'tecnorete') {
            this.options.modules.drawer = {
                ...this.options.modules.drawer,
                insideColor: '#003596',
                outsideColor: '#53BAFF',
                fillColor: '#003596',
                textColor: '#ffffff',
            }
        }
    },

    mounted() {
        if (this.map_center.length != false) {
            this.options.mapCenter.coords = this.map_center
        }

        if (this.map_polygons != false) {
            this.options.modules.drawer.polygons = {
                featureCollection: this.map_polygons,
                editable: false,
                bounds: true,
                duration: 0,
                padding: 25
            }
        }

        axios.get('/api/saved-search-parameters', {params: this.search})
            .then(({data}) => {
                this.filters = data
            })
            .catch(error => {})
    }
}
</script>